import FullscreenWrapper from './fullscreen-wrapper.component.vue';
import FullscreenContent from './fullscreen-content.component.vue';
import FullscreenSuccess from './fullscreen-success.component.vue';
import FullscreenError from './fullscreen-error.component.vue';
import FullscreenLoading from './fullscreen-loading.component.vue';

export {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
};
